export default {
  agentools: {
    title: "Search Properties",
    radioOptButton: {
      sale: "Sale",
      rent: "Rent",
      both: "All",
    },
    keywordSearch: {
      placeHolder: "Search by keyword, agency no, phone no.",
    },
    common: {
      emptyHeader:
        "We couldn't find any properties that match your refinements.",
      emptySubHeader:
        "Try changing your criteria to find the property you are after.",
      all: "All",
    },
    filters: {
      label: "Filters",
      search: "Show properties",
      price: "Price",
      filter: "Filter",
      source: { title: "Source" },
      listingType: { title: "Listing type" },
      fromDate: { title: "Start date" },
      toDate: { title: "End date" },
    },
    table: {
      column: {
        type: "Type",
        propertyType: "Property type",
        description: "Description",
        price: "Price",
        source: "Source",
        contact: "Contact",
        date: "Date",
      },
    },
    sort: {
      dateAsc: "Date oldest - newest",
      dateDesc: "Date newest - oldest",
      priceAsc: "Price lowest - highest",
      priceDesc: "Price highest - lowest",
    },
  },
};
